<script setup lang="ts">
interface Breadcrumbs {
  name: string
  href: string
  rel?: string
}
withDefaults(defineProps<{ breadcrumbs: Breadcrumbs[] }>(), {  })
</script>
<template>
  <div class="gbreadcrumbs w-full">
    <ol
      class="text-v2-secondary leading-snug font-semibold text-md flex gap-1 px-4 py-6
            items-center justify-center whitespace-nowrap"
    >
      <template v-for="(breadcrumb, index) of breadcrumbs" :key="breadcrumb.href">
        <li class="inline-block">
          <a :href="breadcrumb.href" :rel="breadcrumb.rel" class="text-v2-secondary text-sm">
            <span>{{ breadcrumb.name }}</span>
          </a>
        </li>
        <li v-if="index < breadcrumbs.length-1" aria-hidden="true" class="inline-flex">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M5.35928 12.2926C5.27178 12.2269 5.22803 12.1394 5.22803
              12.0519C5.22803 11.9644 5.27178 11.8769 5.3374 11.8113L9.29678 7.50193L5.3374 3.17068C5.20615
              3.03943 5.20615 2.82068 5.35928 2.68943C5.49053 2.55818 5.70928 2.55818 5.84053 2.7113L10.0405
              7.2613C10.1718 7.39255 10.1718 7.58943 10.0405 7.72068L5.84053 12.2707C5.70928 12.4238 5.49053
              12.4238 5.35928 12.2926Z"
            />
          </svg>
        </li>
      </template>
    </ol>
  </div>
</template>
<style lang="scss">
    .gbreadcrumbs {
      background-color: #f3f9ff;

      li:last-of-type span {
        color: #111e36;
      }
    }
</style>
